import {TELEPHONY_CALL_PAIRING_RESOURCES} from '../constants/TELEPHONY_CALL_PAIRING_RESOURCES';

export type TelephonyCallPairingResource = (typeof TELEPHONY_CALL_PAIRING_RESOURCES)[number];
